<template>
  <div :class="['fixed-top navbar-elevation-all d-flex', { 'english-layout': isEnglish }]">
    <nav
      class="navbar navbar-expand-lg navbar-expand-md navbar-expand-sm navbar-dark navbar-elevation top-nav-container flex-grow-1"
    >
      <div class="mobile-navbar-logo">
        <router-link class="navbar-brand" :to="{ path: '/' }">
          <img v-if="$i18n.locale === 'zh'" class="navbar-logo" src="../../assets/topNav/lonxun-logo-01.png"/>
          <img v-else class="navbar-logo" src="../../assets/topNav/lonxun-logo-01-en.png"/>
      </router-link>
      </div>

      <button
        class="navbar-toggler topnav-toggler-icon"
        type="button"
        data-toggle="collapse"
        data-target="#top-nav-collapse"
      >
        <div class="navbar-toggler-icon-1"></div>
        <div class="navbar-toggler-icon-2"></div>
        <div class="navbar-toggler-icon-2"></div>
      </button>

      <div
        class="collapse navbar-collapse top-navbar-collapse mobile-nav-collapse"
        id="top-nav-collapse"
      >
        <ul
          class="nav navbar-nav pop-menu t2-head head-font nav-stacked nav-ul mobile-nav-ul"
        >
          <li class="nav-item navbar-collapse dropdown mobile-dropdown-item">
            <label class="nav-link nav-text" @click="toHome">{{ $t("navbar.Home") }}&nbsp;</label>
          </li>
          <div class="mobile-navbar-dropdown-line"></div>

          <li class="nav-item navbar-collapse dropdown mobile-dropdown-item">
            <label
              class="nav-link nav-text dropdown-toggle dropdown-toggle-split"
              id="nav-menu-about"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              >{{ $t("navbar.About") }}&nbsp;</label
            >
            <div
              class="dropdown-menu navbar-dropdown-menu mobile-navbar-dropdown-menu"
              aria-labelledby="nav-menu-about"
            >
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="toCompanyIntroduce"
                >{{ $t("navbar.CompanyProfile") }}</a
              >
              <div class="navbar-dropdown-line"></div>
              <a v-if="$i18n.locale === 'zh'"
                class="dropdown-item navbar-dropdown-item"
                @click="toCompanyNews"
                >{{ $t("navbar.CompanyNews") }}</a
              >
              <a v-else
                class="dropdown-item navbar-dropdown-item"
                :href="PWMAT_RESOURCE + 'PWmat_Brochures.pdf'"
                target="_blank"
                >{{ $t("navbar.CompanyNews") }}</a
              >
              <div class="navbar-dropdown-line"></div>
              <a class="dropdown-item navbar-dropdown-item" @click="toAcademic"
                >{{ $t("navbar.AcademicDemo") }}</a
              >
              <div class="navbar-dropdown-line"></div>
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="toIndustrial"
                >{{ $t("navbar.IndustryDemo") }}</a
              >
              <div class="navbar-dropdown-line"></div>
              <!-- <a class="dropdown-item navbar-dropdown-item" @click="toCooperate"
                >{{ $t("navbar.Customers") }}</a
              >
              <div class="navbar-dropdown-line"></div>
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="toContactUs"
                >{{ $t("navbar.ContactUs") }}</a
              >
              <div class="navbar-dropdown-line"></div> -->
              <a class="dropdown-item navbar-dropdown-item" @click="toJoinUs">{{
                $t("navbar.JoinUs")
              }}</a>
            </div>
          </li>
          <div class="mobile-navbar-dropdown-line"></div>

          <li class="nav-item navbar-collapse dropdown mobile-dropdown-item">
            <label
              class="nav-link nav-text dropdown-toggle dropdown-toggle-split"
              id="nav-menu-produce"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              >{{ $t("navbar.product") }}&nbsp;</label
            >
            <div
              class="dropdown-menu navbar-dropdown-menu mobile-navbar-dropdown-menu dropright"
              aria-labelledby="nav-menu-produce"
            >
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="toPWmatIntroduce"
                >PWmat&nbsp;</a
              >
              <!-- <div class="navbar-dropdown-line"></div> -->
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="toPWmatTrialIntroduce"
                >PWstudio</a
              >
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="toMLFFIntroduce"
                >MatPL</a
              >
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="toQStudioIntroduce"
                >Q-Studio</a
              >
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="toQStudioAIIntroduce"
                >Q-Studio AI</a
              >
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="toPWMGUIIntroduce"
                >Q-Flow</a
              >
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="toIntegration"
                >{{ $t("navbar.Solution") }}</a
              >
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="toFeaturedCapabilities"
                >{{ $t("navbar.Features") }}</a
              >
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="toModuleDownload"
                >PWmat Module</a
              >
              <!-- <a
                class="dropdown-item navbar-dropdown-item"
                @click="topwkitDownload"
                >PWkit</a
              > -->
            </div>
          </li>
          <div class="mobile-navbar-dropdown-line"></div>

          <li class="nav-item navbar-collapse dropdown mobile-dropdown-item">
            <a
              class="nav-link nav-text dropdown-toggle-split"
              @click="toIntelliMatIntroduce"
              target="_blank"
              >IntelliMat</a
            >

            <div class="mobile-navbar-dropdown-line"></div>
          </li>

          <li class="nav-item navbar-collapse dropdown mobile-dropdown-item">
            <a
              class="nav-link nav-text dropdown-toggle-split"
              href="https://mcloud.lonxun.com"
              target="_blank"
              >Mcloud</a
            >

            <div class="mobile-navbar-dropdown-line"></div>
          </li>

          <li class="nav-item navbar-collapse dropdown mobile-dropdown-item">
            <label
              class="nav-link nav-text dropdown-toggle dropdown-toggle-split"
              id="nav-menu-download"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              >{{ $t("navbar.Download") }}&nbsp;</label
            >
            <div
              class="dropdown-menu navbar-dropdown-menu mobile-navbar-dropdown-menu dropright"
              aria-labelledby="nav-menu-download"
            >
              <div class="dropdown-submenu">
                <a
                  class="dropdown-item navbar-dropdown-item dropdown-toggle dropdown-toggle-split"
                  id="nav-menu-software-download"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  >{{ $t("navbar.SoftWareDownload") }}&nbsp;</a
                >
                <div
                  class="dropdown-menu navbar-dropdown-menu mobile-navbar-dropdown-menu"
                  aria-labelledby="nav-menu-software-download"
                >
                  <div class="navbar-dropdown-line"></div>
                  <div class="navbar-dropdown-line"></div>
                  <a v-if="$i18n.locale === 'zh'"
                    class="dropdown-item navbar-dropdown-item"
                    target="_blank"
                    @click="toPWstudioIntroduce"
                    >{{ $t("navbar.PWmatTry") }}</a
                  >
                  <a v-else
                    class="dropdown-item navbar-dropdown-item"
                    target="_blank"
                    href="https://www.wjx.top/vm/QFVmwn1.aspx"
                    >{{ $t("navbar.PWmatTry") }}</a
                  >
                  <a
                    class="dropdown-item navbar-dropdown-item"
                    @click="toGPUDownload"
                    >{{ $t("navbar.PWmatGPU") }}</a
                  >
                  <div class="navbar-dropdown-line"></div>
                  <div class="navbar-dropdown-line"></div>
                  <a
                    class="dropdown-item navbar-dropdown-item"
                    @click="toDCUDownload"
                    >{{ $t("navbar.PWmatDCU") }}</a
                  >
                  <a
                    class="dropdown-item navbar-dropdown-item"
                    @click="toCPUDownload"
                    >{{ $t("navbar.PWmatCPU") }}</a
                  >
                  <a
                    class="dropdown-item navbar-dropdown-item"
                    @click="toWindowsDownload"
                    >{{ $t("navbar.PWmatWin") }}</a
                  >
                </div>
              </div>
              <div class="navbar-dropdown-line"></div>
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="toLS3DFDownload"
                >LS3DF</a
              >
              <div class="navbar-dropdown-line"></div>
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="toMatPLDownload"
                >MatPL</a
              >
              <div class="navbar-dropdown-line"></div>
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="toPotentialDownload"
                >{{ $t("navbar.PotentialDownload") }}</a
              >
              <!-- <div class="navbar-dropdown-line"></div> -->
              <div class="navbar-dropdown-line"></div>
              <div v-if="$i18n.locale === 'zh'" class="dropdown-submenu">
                <a
                  class="dropdown-item navbar-dropdown-item dropdown-toggle dropdown-toggle-split"
                  id="nav-menu-manual"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  >{{ $t("navbar.PWmatManual") }}&nbsp;</a
                >
                <div
                  class="dropdown-menu dropdown-"
                  aria-labelledby="nav-menu-manual"
                >
                  <a
                    class="dropdown-item navbar-dropdown-item"
                    :href="PWMAT_RESOURCE + 'Manual_cn.pdf'"
                    target="_blank"
                    >{{ $t("navbar.PWmatzhVer") }}</a
                  >
                  <div class="navbar-dropdown-line"></div>
                  <a
                    class="dropdown-item navbar-dropdown-item"
                    :href="PWMAT_RESOURCE + 'Manual.pdf'"
                    target="_blank"
                    >{{ $t("navbar.PWmatenVer") }}</a
                  >
                </div>
              </div>
              <a v-else class="dropdown-item navbar-dropdown-item"
                target="_blank"
                :href="PWMAT_RESOURCE + 'Manual.pdf'"
                >{{ $t("navbar.PWmatManual") }}
              </a>
              <div class="navbar-dropdown-line"></div>
              <a
                class="dropdown-item navbar-dropdown-item"
                href="http://doc.lonxun.com/Q-Flow/"
                target="_blank"
                >{{ $t("navbar.QflowManual") }}</a
              >
              <div class="navbar-dropdown-line"></div>
              <a
                class="dropdown-item navbar-dropdown-item"
                href="http://doc.lonxun.com/Q-Studio/"
                target="_blank"
                >{{ $t("navbar.QstudioManual") }}</a
              >
              <div class="navbar-dropdown-line"></div>
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="toUtilityDownload"
                >PWmat Utility</a
              >
              <div class="navbar-dropdown-line"></div>
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="toModuleDownload"
                >PWmat Module</a
              >
              <div class="navbar-dropdown-line"></div>
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="topwkitDownload"
                >PWkit</a
              >
            </div>
          </li>
          <div class="mobile-navbar-dropdown-line"></div>

          <li class="nav-item navbar-collapse dropdown mobile-dropdown-item">
            <label
              class="nav-link nav-text dropdown-toggle dropdown-toggle-split"
              id="nav-menu-course"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              >{{ $t("navbar.Course") }}&nbsp;</label
            >
            <div
              class="dropdown-menu navbar-dropdown-menu mobile-navbar-dropdown-menu dropright"
              aria-labelledby="nav-menu-course"
            >
              <div class="navbar-dropdown-line"></div>
              <a class="dropdown-item navbar-dropdown-item" @click="toVideo"
                >{{ $t("navbar.Video") }}</a
              >
              <a v-if="$i18n.locale === 'zh'" class="dropdown-item navbar-dropdown-item" @click="toTutorials"
                >{{ $t("navbar.Tutorial") }}</a
              >
              <a v-if="$i18n.locale === 'zh'" class="dropdown-item navbar-dropdown-item" @click="toCourse"
                >{{ $t("navbar.CommonParameter") }}</a
              >
              <a v-else class="dropdown-item navbar-dropdown-item"
                target="_blank"
                :href="PWMAT_RESOURCE + 'Manual.pdf'"
                >{{ $t("navbar.CommonParameter") }}
              </a>
              <div class="navbar-dropdown-line"></div>
              <a class="dropdown-item navbar-dropdown-item" @click="toCase"
                >{{ $t("navbar.TypicalLiterature") }}</a
              >
              <a class="dropdown-item navbar-dropdown-item" @click="toReadPaper"
                >{{ $t("navbar.PublishedPapers") }}</a
              >
              <a
                class="dropdown-item navbar-dropdown-item"
                @click="toModuleClass"
                >{{ $t("navbar.ModuleClassroom") }}</a
              >
              <div class="navbar-dropdown-line"></div>
              <!-- <div class="navbar-dropdown-line"></div>
              <a class="dropdown-item navbar-dropdown-item" @click="toTrain"
                >{{ $t("navbar.GettingStartedVideo") }}</a
              >
              <div class="navbar-dropdown-line"></div>
              <a class="dropdown-item navbar-dropdown-item" @click="toCamp"
                >{{ $t("navbar.SpecialVideo") }}</a
              >
              <div class="navbar-dropdown-line"></div>
              <a class="dropdown-item navbar-dropdown-item" @click="toSeminar"
                >{{ $t("navbar.BigVideo") }}</a
              >
              <div class="navbar-dropdown-line"></div> -->
            </div>
          </li>

          <li class="nav-item navbar-collapse dropdown mobile-dropdown-item">
            <label
              class="nav-link nav-text dropdown-toggle dropdown-toggle-split"
              id="nav-menu-more"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              >{{ $t("navbar.More") }}&nbsp;</label
            >
            <div
              class="dropdown-menu navbar-dropdown-menu mobile-navbar-dropdown-menu"
              aria-labelledby="nav-menu-more"
            >
              <a v-if="$i18n.locale === 'zh'"
                class="dropdown-item navbar-dropdown-item"
                target="_blank"
                @click="toPWstudioIntroduce"
                >{{ $t("navbar.PWmatTry") }}</a
              >
              <a v-else
                class="dropdown-item navbar-dropdown-item"
                target="_blank"
                href="https://www.wjx.top/vm/QFVmwn1.aspx"
                >{{ $t("navbar.PWmatTry") }}</a
              >
              <div class="navbar-dropdown-line"></div>
              <a class="dropdown-item navbar-dropdown-item" @click="toLog">{{
                $t("navbar.Log")
              }}</a>
              <div class="navbar-dropdown-line"></div>
              <a class="dropdown-item navbar-dropdown-item" @click="toTestLog"
                >{{ $t("navbar.BugLog") }}</a
              >
              <div class="navbar-dropdown-line"></div>
              <a class="dropdown-item navbar-dropdown-item" @click="toPaper">{{
                $t("navbar.Paper")
              }}</a>
              <div class="navbar-dropdown-line"></div>
              <a class="dropdown-item navbar-dropdown-item" @click="toFAQ"
                >FAQ</a
              >
            </div>
          </li>
          <div class="mobile-navbar-dropdown-line"></div>
        </ul>
      </div>
    </nav>
    <div class="nav-item navbar-collapse dropdown mobile-dropdown-item align-self-center" style="max-width: 100px; margin-right: 20px;">
      <label class="nav-link nav-text" @click="toggleLanguage"
        style="cursor: pointer; display: inline-block;">{{ showLanguageName }}&nbsp;</label>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import LangStorage from "./../../helpers/lang";
import { PWMAT_RESOURCE, COURSE_URL } from "./../../helpers/consts";
import $ from "jquery";
import LangHelper from '@/helpers/lang'

export default {
  name: "HelloWorld",
  props: {},
  created() {
    // 初始化：显示相反语言名称
    this.displayLang = this.$i18n.locale === 'zh' ? 'en' : 'zh'
  },
  data() {
    return {
      PWMAT_RESOURCE,
      COURSE_URL,
      displayLang: 'zh'    // 初始化显示值（与实际语言相反）
    };
  },
  computed: {
    ...mapState({
      testDocuments: (state) => state.TestDocument.testDocuments.info,
    }),
    showLanguageName() {
      return this.displayLang === 'zh' ? '中文' : 'English'
    },
    isEnglish() {
      return this.displayLang === 'zh'; // 直接复用 displayLang
    },
  },
  // created(){
  // this.$store.dispatch('getTestDocument').then(res => {

  //console.log(this.testDocuments)
  // })
  // },
  methods: {
    changeLanguage() {
      let lang = LangStorage.getLang("en");
      if (lang === "en") {
        this.$i18n.locale = "zh";
      } else {
        this.$i18n.locale = "en";
      }
      LangStorage.setLang(this.$i18n.locale);
    },
    toggleLanguage() {
      // 确定新的实际语言（与当前显示值相同）
      const newLang = this.displayLang

      // 先持久化语言，再强刷页面以完整切换中英文内容
      LangHelper.setLang(newLang)
      window.location.reload()
    },
    toHome() {
      this.$router.push({ name: "Home" });
      $(".collapse").collapse("hide");
    },
    toCompanyIntroduce() {
      this.$router.push({ name: "CompanyIntroduce" });
      $(".collapse").collapse("hide");
    },
    toCooperate() {
      this.$router.push({ name: "CompanyIntroduce", hash: "#customers" });
      $(".collapse").collapse("hide");
    },
    toContactUs() {
      this.$router.push({ name: "CompanyIntroduce", hash: "#contact" });
      $(".collapse").collapse("hide");
    },
    toCompanyNews() {
      this.$router.push({ name: "CompanyNews", params: { page: 1 } });
      $(".collapse").collapse("hide");
    },
    toJoinUs() {
      this.$router.push({ name: "JoinUs" });
      $(".collapse").collapse("hide");
    },
    toPWstudioIntroduce() {
      this.$router.push({ name: 'PWstudioIntroduce' })
    },
    toPWmatIntroduce() {
      this.$router.push({ name: "PWmatIntroduce" });
      $(".collapse").collapse("hide");
    },
    toPWmatTrialIntroduce() {
      this.$router.push({ name: "PWstudioIntroduce" });
      $(".collapse").collapse("hide");
    },
    toMLFFIntroduce() {
      this.$router.push({ name: "MLFFIntroduce" });
      $(".collapse").collapse("hide");
    },
    toLS3DFIntroduce() {
      this.$router.push({ name: "LS3DFIntroduce" });
      $(".collapse").collapse("hide");
    },
    toPWMGUIIntroduce() {
      this.$router.push({ name: "PWMGUIIntroduce" });
      $(".collapse").collapse("hide");
    },
    toQStudioIntroduce() {
      this.$router.push({ name: "QStudioIntroduce" });
      $(".collapse").collapse("hide");
    },
    toQStudioAIIntroduce() {
      this.$router.push({ name: "QStudioAIIntroduce" });
      $(".collapse").collapse("hide");
    },
    toIntegration() {
      this.$router.push({ name: "Integration" });
      $(".collapse").collapse("hide");
    },
    toMSTATIONIntroduce() {
      this.$router.push({ name: "MSTATIONIntroduce" });
      $(".collapse").collapse("hide");
    },
    toMCLUSTERIntroduce() {
      this.$router.push({ name: "MCLUSTERIntroduce" });
      $(".collapse").collapse("hide");
    },
    toMcloudIntroduce() {
      this.$router.push({ name: "McloudIntroduce" });
      $(".collapse").collapse("hide");
    },
    toDMSTATIONIntroduce() {
      this.$router.push({ name: "DMSTATIONIntroduce" });
      $(".collapse").collapse("hide");
    },
    toIndustrial() {
      this.$router.push({ name: "Industrial" });
      $(".collapse").collapse("hide");
    },
    toAcademic() {
      this.$router.push({ name: "Academic" });
      $(".collapse").collapse("hide");
    },
    toPotentialDownload() {
      this.$router.push({ name: "PotentialDownload" });
      $(".collapse").collapse("hide");
    },
    toModuleDownload() {
      this.$router.push({ name: "ModuleDownload" });
      $(".collapse").collapse("hide");
    },
    toCourse() {
      window.open(this.COURSE_URL);
      $(".collapse").collapse("hide");
    },
    toVideo() {
      this.$router.push({ name: "VideoTutorial" });
      $(".collapse").collapse("hide");
    },
    toTutorials() {
      this.$router.push({ name: "Tutorials" });
      $(".collapse").collapse("hide");
    },
    toLS3DFDownload() {
      this.$router.push({ name: "LS3DFDownload" });
      $(".collapse").collapse("hide");
    },
    toMatPLDownload() {
      this.$router.push({ name: "MatPLDownload" });
      $(".collapse").collapse("hide");
    },
    toVedioCourse() {
      this.$router.push({ name: "CourseVedio" });
      $(".collapse").collapse("hide");
    },
    toTrain() {
      this.$router.push({ name: "Train" });
      $(".collapse").collapse("hide");
    },
    toLongxunRoom() {
      this.$router.push({ name: "LongxunRoom" });
      $(".collapse").collapse("hide");
    },
    toQuickStartTutorial() {
      this.$router.push({ name: "QuickStartTutorial" });
      $(".collapse").collapse("hide");
    },
    toCase() {
      this.$router.push({ name: "Case" });
      $(".collapse").collapse("hide");
    },
    toReadPaper() {
      this.$router.push({ name: "ReadPaper" });
      $(".collapse").collapse("hide");
    },
    toModuleClass() {
      this.$router.push({ name: "ModuleClass" });
      $(".collapse").collapse("hide");
    },
    toCamp() {
      this.$router.push({ name: "Camp" });
      $(".collapse").collapse("hide");
    },
    toSeminar() {
      this.$router.push({ name: "Seminar" });
      $(".collapse").collapse("hide");
    },
    toFAQ() {
      this.$router.push({ name: "FAQPage" });
      $(".collapse").collapse("hide");
    },
    toForum() {
      this.$router.push({ name: "Forum" });
      $(".collapse").collapse("hide");
    },
    toPaper() {
      this.$router.push({ name: "PaperPage" });
      $(".collapse").collapse("hide");
    },
    toLog() {
      this.$router.push({ name: "LogPage" });
      $(".collapse").collapse("hide");
    },
    totrial() {
      this.$router.push({ name: "trialPage" });
      $(".collapse").collapse("hide");
    },
    toPWmatTrialDownload() {
      this.$router.push({ name: "PWmatTrialDownload" });
      $(".collapse").collapse("hide");
    },
    toPWmatFreeDownload() {
      this.$router.push({ name: "PWmatFreeDownload" });
      $(".collapse").collapse("hide");
    },
    toGPUDownload() {
      this.$router.push({ name: "GPUDownload" });
      $(".collapse").collapse("hide");
    },
    toDCUDownload() {
      this.$router.push({ name: "DCUDownload" });
      $(".collapse").collapse("hide");
    },
    toCPUDownload() {
      this.$router.push({ name: "CPUDownload" });
      $(".collapse").collapse("hide");
    },
    topwkitDownload() {
      this.$router.push({ name: "pwkitDownload" });
      $(".collapse").collapse("hide");
    },
    toHighThroughputDownload() {
      this.$router.push({ name: "HighThroughputDownload" });
      $(".collapse").collapse("hide");
    },
    toMCLUSTERDownload() {
      this.$router.push({ name: "MCLUSTERDownload" });
      $(".collapse").collapse("hide");
    },
    toWindowsDownload() {
      this.$router.push({ name: "WindowsDownload" });
      $(".collapse").collapse("hide");
    },
    toUtilityDownload() {
      this.$router.push({ name: "UtilityDownload" });
      $(".collapse").collapse("hide");
    },
    toTestDocument($id) {
      this.$router.push({ name: "TestDocument", params: { id: $id } });
    },
    toTestLog() {
      this.$router.push({ name: "TestLog" });
    },
    toFeaturedCapabilities() {
      this.$router.push({ name: "FeaturedCapabilities" });
      $(".collapse").collapse("hide");
    },
    toIntelliMatIntroduce() {
      this.$router.push({ name: "IntelliMatIntroduce" });
    },
  },
};
</script>

<style scoped>
.top-nav-container {
  width: 100%;
  padding-right: 15px !important;
  padding-left: 15px !important;
  margin-right: auto;
  margin-left: auto;
}
.navbar-elevation-all {
  background-color: rgba(255, 255, 255, 0.85);
}
.navbar-elevation {
  padding: 0;
  height: 70px;
}
.navbar-logo {
  margin-top: 10px;
  height: 25px;
  float: left;
}

.nav-item {
  float: right;
}
.nav-item:hover,
.nav-item:active {
  background: #e6e6e6;
}
.nav-text {
  cursor: pointer;
  font-size: 18px;
  font-weight: 400;
  color: #4f4c4d !important;
  padding: 15px 20px 15px 20px !important;
  margin: 0 !important;
}
.nav-text-a {
  cursor: pointer;
  font-size: 18px;
  font-weight: 400;
  color: #4f4c4d !important;
}
.nav-text-a:hover,
.nav-text-a:active,
.nav-text-a:focus {
  text-decoration: none;
}
.navbar-dropdown-item {
  padding: 10px 24px 10px 24px;
  font-weight: 400;
  color: #4f4c4d !important;
  cursor: pointer;
}
.navbar-dropdown-item:hover,
.navbar-dropdown-item:active {
  background: #e6e6e6;
  color: #4f4c4d !important;
  text-decoration: none !important;
}
.navbar-dropdown-menu {
  background: #fefefe;
  border-radius: 2px;
}
.navbar-dropdown-line {
  height: 1px;
  background: rgba(255, 255, 255, 0.2);
}
.topnav-toggler-icon {
  border-color: rgba(0, 0, 0, 1) !important;
  border: 0 solid;
}
.topnav-toggler-icon:focus {
  box-shadow: none !important;
  outline: none !important;
}
.navbar-toggler-icon-1 {
  width: 16px;
  height: 2px;
  background: rgba(73, 145, 201, 1);
}
.navbar-toggler-icon-2 {
  margin-top: 6px;
  width: 16px;
  height: 2px;
  background: rgba(73, 145, 201, 1);
}

@media screen and (max-width: 580px) {
  .top-nav-container {
    max-width: 100%;
  }
  .top-nav-container {
    max-width: 100%;
  }
  .mobile-navbar-logo {
    margin-left: 6px;
  }
  .mobile-dropdown-item {
    margin: 0;
  }
  .mobile-navbar-dropdown-line {
    height: 1px;
    background: rgba(0, 0, 0, 0.2);
    margin: 0 25px 0 25px;
  }
  .nav-item {
    height: auto;
    text-align: left !important;
  }
  .mobile-navbar-dropdown-menu {
    background: rgba(0, 0, 0, 0);
    border: 0 solid;
  }
  .navbar {
    position: relative;
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -ms-flex-align: center;
    -webkit-box-align: center;
    align-items: center;
    -ms-flex-pack: justify;
    -webkit-box-pack: justify;
    justify-content: space-between;
    padding: 0.5rem 1rem;
  }
  .navbar-collapse {
    flex-basis: 100% !important;
  }
  .navbar-toggler {
    display: block !important;
  }
  .mobile-nav-collapse {
    margin-top: 10px !important;
    margin-left: -16px;
    margin-right: -16px;
    background: white;
    z-index: 999;
    border-top: 1px solid rgba(73, 145, 201, 1);
  }
  .collapse:not(.show) {
    display: none !important;
  }
  .nav-item {
    margin-left: 0;
    float: left;
    text-align: center;
  }
  .nav-text {
    padding: 7px 25px 5px 25px !important;
    font-size: 16px !important;
  }
  .navbar-dropdown-item {
    padding: 5px 24px 5px 24px !important;
    font-size: 16px !important;
  }
  .mobile-nav-ul {
    padding-top: 5px;
    padding-bottom: 15px;
  }
  .dropdown-menu {
    padding: 4px 0 !important;
  }
  .navbar-logo {
    height: 15px;
  }
}
@media screen and (min-width: 580px) and (max-width: 769px) {
  .top-nav-container {
    max-width: 100%;
  }
  .top-navbar-collapse {
    position: absolute;
    bottom: 0;
    right: 0;
  }
  .nav-text {
    padding-left: 8px !important;
    padding-right: 8px !important;
    font-size: 16px;
  }
  .navbar-logo {
    height: 15px;
    margin-top: 20px;
  }
}
@media screen and (min-width: 769px) and (max-width: 1000px) {
  .top-nav-container {
    max-width: 100%;
  }
  .top-navbar-collapse {
    position: absolute;
    bottom: 0;
    right: 0;
  }
  .nav-text[data-v-3de3191c] {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}
@media screen and (min-width: 1000px) and (max-width: 1144px) {
  .top-nav-container {
    max-width: 968px;
  }
  .top-navbar-collapse {
    position: absolute;
    bottom: 0;
    right: 0;
  }
}
@media screen and (min-width: 1100px) and (max-width: 1444px) {
  .top-nav-container {
    max-width: 1068px;
  }
  .top-navbar-collapse {
    position: absolute;
    bottom: 0;
    right: 0;
  }
}
@media screen and (min-width: 1444px) {
  .top-nav-container {
    max-width: 1300px;
  }
  .top-navbar-collapse {
    position: absolute;
    bottom: 0;
    right: 0;
  }
}
/* pengge add for submenu BEGIN */
.dropdown-submenu:hover > .dropdown-menu {
  display: block;
}
.dropdown-submenu {
  position: relative;
}
.dropdown-submenu > .dropdown-menu {
  top: 0;
  left: 100%;
  margin-top: -6px;
  margin-left: -1px;
  -webkit-border-radius: 0 6px 6px 6px;
  -moz-border-radius: 0 6px 6px;
  border-radius: 0 6px 6px 6px;
}
/* pengge add for submenu END */

/* 英文特有样式 */
.english-layout .nav-text {
  font-size: 16px; /* 缩小字体 */
  padding: 15px 12px 15px 12px !important; /* 调整间距 */
}

.english-layout .navbar-dropdown-item {
  padding: 10px 18px 10px 18px; /* 调整下拉项间距 */
}

/* 针对小屏幕的英文样式调整 */
@media screen and (max-width: 580px) {
  .english-layout .nav-text {
    font-size: 14px !important;
    padding: 7px 15px 5px 15px !important;
  }

  .english-layout .navbar-dropdown-item {
    padding: 5px 18px 5px 18px !important;
    font-size: 14px !important;
  }
}
</style>
